<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ selected }}</span>
		<app-button
			(click)="createAgent()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			>Create agent</app-button
		>
	</div>
</ng-template>

<ng-template #agentTemplate let-item>
	<div class="flex text-truncate">
		<atomic-name-badge
			[firstName]="item.firstName"
			[lastName]="item.lastName"
			size="small"
		></atomic-name-badge>
		<div class="flex flex-col ml-2 truncate">
			<span class="font-bold whitespace-nowrap"
				>{{ item.firstName | titlecase }} {{ item.lastName | titlecase }}</span
			>
			<span class="text-sm whitespace-nowrap">{{
				item.company | capitalize
			}}</span>
		</div>
	</div>
</ng-template>

<app-auto-complete
	(onSelect)="onSelect($event)"
	placeholder="Fire Insurance Agent"
	[itemGroups]="[
		{ items: [{ value: 'createNew' }], template: createNewTemplate },
		{
			items: (fireInsuranceAgents$ | async),
			template: agentTemplate,
			title: 'Fire Insurance Agents',
			noResultsMessage: 'No agents found',
			type: dropdownSelect.SELECT_FIRE_INSURANCE_AGENT,
		},
	]"
	[(ngModel)]="selected"
	name="dual-dropdown-1"
	[minSearchTerm]="2"
	(debounce)="search($event)"
	[loading]="isSearching$ | async"
	width="w-full"
>
</app-auto-complete>
